import Xmark from './Xmark';

export default Xmark;
